import { render, staticRenderFns } from "./general-info.vue?vue&type=template&id=78af4ee7"
import script from "./general-info.vue?vue&type=script&lang=js"
export * from "./general-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports